import React, { useEffect, useState } from "react";

import { Button, Card, Typography } from "antd";
import LogoBackground from "assets/images/diary-bg-img.jpg";
import Logo from "assets/images/logo.svg";

import PersonalityTabs from "./personalityTabs";
import NetworkCall from "network/networkCall";
import Request from "network/request";
import { downloadEvent, redirectToUrl } from "utilities/generalUtility";
import { useLocation } from "react-router-dom";
const { Title } = Typography;

export default function Personality() {
  const location = useLocation();
  const [options, setoption] = useState();
  const [loading, setLoading] = useState(false);
  const [personalityQuestion, setpersonalityQustion] = useState(false);
  const queryParams = new URLSearchParams(location.search);

  const fetchPersonalityTypes = async () => {
    try {
      setLoading(true);
      const res = await NetworkCall.fetch(
        Request.getAllPersonalityTypes(),
        false
      );
      setoption(res?.data?.tableListing);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const redirect = () => {
    downloadEvent("HaveNotTakenMBTI");
    redirectToUrl(
      "/sub-info",
      queryParams.get("diaryId"),
      queryParams.get("diaryTopicId")
    );
  };

  useEffect(() => {
    fetchPersonalityTypes();
  }, []);
  return (
    <React.Fragment>
      {personalityQuestion ? (
        <div className="login-container d-flex">
          <div className="login-bg w-100">
            <img
              className="login-img w-100 h-100"
              src={LogoBackground}
              alt=""
            />
          </div>
          <Card bordered={false} className="login-card">
            <div className="authentication-logo text-center">
              <img className="logo" src={Logo} alt="" />
            </div>
            <Title level={4}>Personality Type</Title>

            <PersonalityTabs
              options={options}
              loading={loading}
            ></PersonalityTabs>
          </Card>
        </div>
      ) : (
        <div className="login-container d-flex">
          <div className="login-bg w-100">
            <img
              className="login-img w-100 h-100"
              src={LogoBackground}
              alt=""
            />
          </div>
          <Card bordered={false} className="login-card sub-info-card">
            <div className="authentication-logo text-center">
              <img className="logo" src={Logo} alt="" />
            </div>
            <h3 className="sub-info-heading">
              Have you ever taken Myers-Briggs Type Indicator(MBTI) personality
              test before?
            </h3>
            <div className="sub-info-btn">
              <Button block size="large" type="ghost" onClick={redirect}>
                No, I haven't taken
              </Button>
              <Button
                block
                size="large"
                type="primary"
                onClick={() => {
                  downloadEvent("HaveTakenMBTITest");
                  setpersonalityQustion(true);
                }}
              >
                Yes, I have taken
              </Button>
            </div>
          </Card>
        </div>
      )}
    </React.Fragment>
  );
}
